import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext } from "react";
import styled from "styled-components";
import { Application, makeRequest } from "../../common/api";
import { ApplicationCard } from "../../common/features/ApplicationCard";
import { UserContext } from "../../common/UserContext";
import { BatchesContext } from "../BatchesContext";

const EmptyStateContainer = styled.div`
    text-align: center;
    padding: 20px 10px;
    background-color: #f8f9ff;
    border-radius: 8px;
`;

const StyledLink = styled.a`
    display: inline-block;
    background-color: #9051a8;
    color: white;
    padding: 12px 24px;
    border-radius: 6px;
    text-decoration: none;
    font-size: 16px;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: #7b4491;
    }
`;

export const YourApplications = () => {
  const [applications, setApplications] = React.useState<Application[] | null>(
    null
  );
  const batches = React.useContext(BatchesContext)?.batches;

  const userContext = useContext(UserContext);
  React.useEffect(() => {
    if (userContext?.user)
      makeRequest("/api/applications", "GET").then((apps: Application[]) => {
        setApplications(apps);
      });
  }, [userContext]);

  const activeBatches = batches?.filter((b) => b.status === "Open");
  const activeBatchesId = activeBatches?.map((b) => b._id);

  const activeApplications = applications?.filter(
    (a) => a.status !== "CANCELLED" && activeBatchesId.includes(a.batchId)
  ) || [];
  const inactiveApplications = applications?.filter(
    (a) => !activeBatchesId.includes(a.batchId)
  ) || [];

  return (
    <div>
      {activeApplications.length > 0 && (
        <>
          <h3 style={{ fontWeight: "bold" }}>Your Ongoing Enrollments </h3>
          {!batches && <FontAwesomeIcon icon="circle-notch" spin={true} />}
          {batches &&
            activeApplications?.map((app) => (
              <ApplicationCard
                key={app._id}
                application={app}
                batches={batches}
              />
            ))}
        </>
      )}
      {activeApplications.length === 0 && (
        <EmptyStateContainer>
          <h3 style={{ fontWeight: "bold" }}>No Ongoing Enrollments </h3>
            <p>
                You don't have any active enrollments at the moment.
            </p>
            <StyledLink href="/enroll">
                Check Available Courses
            </StyledLink>
        </EmptyStateContainer>
      )}
      {inactiveApplications.length > 0 && (
        <>
          <h3 style={{ fontWeight: "bold" }}>Your Past Enrollments </h3>
          {inactiveApplications?.map((app) => (
            <ApplicationCard
              key={app._id}
              application={app}
              batches={batches}
              disabled={true}
            />
          ))}
        </>
      )}
    </div>
  );
};
